import { lazy } from 'react'
import { getLinkObject } from '../../services/getLinkObject'

export const REPORTER_LINKS = {
  TEMPLATES: getLinkObject(
    '/reporter/templates',
    'Templates',
    lazy(() => import('./components/templatesPanel/TemplatesPanel')),
    {},
    'GetTemplatePrivilege'
  ),
  REPORTS: getLinkObject(
    '/reporter/reports',
    'Reports',
    lazy(() => import('./components/reportsPanel/ReportsPanel')),
    {},
    'GetReportPrivilege'
  ),
  SCHEDULE: getLinkObject(
    '/reporter/schedule',
    'Schedule',
    lazy(() => import('./components/schedulesPanel/SchedulesPanel')),
    {},
    'ManageScheduledReportsPrivilege'
  )
}

export const MAX_ITEM_NAME_LENGTH = 200
export const MAX_PARAMETER_NAME_LENGTH = 50
